import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActivityPageComponent } from './activity-page.component';
import { SaveUrlParamsGuard } from 'src/app/shared/guards/save-url-params.guard';
import { OptionalLoginGuard } from 'src/app/shared/guards/optionalLoginGuard';

const routes: Routes = [
  {
    path: ':activityId/:activityOid',
    component: ActivityPageComponent,
    canActivate: [SaveUrlParamsGuard, OptionalLoginGuard],
  },
  {
    path: ':activityId/:activityOid/:restart',
    component: ActivityPageComponent,
    canActivate: [SaveUrlParamsGuard, OptionalLoginGuard],
  },
  {
    path: '**',
    loadChildren: () =>
      import('../../pages/page-not-found/page-not-found.module').then(
        m => m.PageNotFoundModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ActivityRoutingModule {}
